export default __webpack_public_path__ + "static/media/paw.c36dbf3f.svg";